import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useUser} from "../UserContext";

const UserLink = ({user, style}) => {
    const navigate = useNavigate()
    const [defaultStyle, setDefaultStyle] = useState({cursor: "inherit"})
    const myUser = useUser();

    useEffect(() => {
        if(user.isActualUser || user.isLoggedIn) {
            setDefaultStyle({cursor: "pointer"})
        }
    }, [user]);

    const goToUser = (user) => {
        //If we are logged in and are clicking on our own username, we should go to our own profile
        if(myUser.isLoggedIn && user.username === myUser.username) {
            navigate('/my-profile')
        } else if(user.isActualUser) {
            navigate(`/profile?username=${user.username}`)
        }
    }



    return (
        <p style={{...defaultStyle, ...style}} onClick={() => goToUser(user)}>{user.username}</p>
    )
}

export default UserLink;